<template>

  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <horses-table />
      </div>
    </div>
  </div>

</template>


<script>
import HorsesTable from "../components/HorsesTable.vue";

export default {
  name: "horses",
  data() {
    return {};
  },
  components: {
    HorsesTable,
  },
  methods: {
  },
  created() {
    this.$store.dispatch('updateBreadcrumbs', []);
  },
};
</script>
